import { IMAGELOADINGENUMS } from '@et/types/Enums'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  gatsbyImage: {
    gatsbyImageData: IGatsbyImageData
  }
  name: string
  showName?: boolean
}

function BrushTipStamp(props: Props) {
  const { name, gatsbyImage, showName } = props

  return (
    <div className='relative mb-16 bg-red-300 md:mx-0'>
      <div className='relative bg-white z-2'>
        <div className='opacity-75'>
          {gatsbyImage && <GatsbyImage alt={name} image={gatsbyImage.gatsbyImageData} loading={IMAGELOADINGENUMS.LAZY} />}
        </div>
        {showName && <div className='absolute top-[108%] left-4 lg:left-1'>
          <h3 className='text-lg italic text-grey-800 font-sentinel__MediumItal'>{name}</h3>
        </div>}
      </div>
      <div className='absolute bgShadow z-1 bottom-0 w-[70%] h-[80%] left-1/2 -translate-x-1/2 shadow-[0_21px_55px_rgb(0,0,0,0.18)]'></div>
    </div>

  )
}

export default BrushTipStamp
